module.exports = __webpack_public_path__ + "static/media/QRCode_PatientPortal_large_cropped.034e225f.png";